import React from "react"
import Header from "../components/Header"
import Hero from "../components/distribute-attendees-photos-from-the-event/Hero"
import Clients from "../components/landing-page/Clients"
import Layout from "../components/Layout"

import "../index.css"
import Features from "../components/distribute-attendees-photos-from-the-event/Features"
import MagicWithUs from "../components/inner-page/MagicWithUs"
import Feebacks from "../components/landing-page/Feebacks"
import MoreCaseStudy from "../components/case-study/MoreCaseStudy"

export function Index() {
  return (
    <Layout
      title="Distribute Event Photos via WhatsApp - AI Face Recognition"
      description="Automatically deliver event photos to attendees via WhatsApp using face recognition technology. Instant & secure."
      keywords={[
        "event photo distribution, WhatsApp photo delivery, face recognition photo sharing, AI photo delivery, automated attendee photos, instant photo distribution, event photo automation, smart photo sharing, facial recognition events, attendee photo matching, AI-powered photo distribution, secure photo delivery, real-time photo sharing, event photography automation, personalized photo delivery",
      ]}
    >
      <Header />
      <Hero />
      <Features />
      <Clients />
      <Feebacks hasHeading />
      <MoreCaseStudy currentPage="home" itemsToShow={6} />
      <MagicWithUs />
    </Layout>
  )
}

export default Index
